import { render } from "./NewMembersearch.vue?vue&type=template&id=12ecbc56"
import script from "./NewMembersearch.vue?vue&type=script&lang=js"
export * from "./NewMembersearch.vue?vue&type=script&lang=js"

import exportComponent from "/mnt/extra-storage/gafwa_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__